module.exports = __webpack_public_path__ + "static/media/good_job.fc002743.png";